import type { RouteObject } from 'react-router'
import { Navigate } from 'react-router'
import { PATHS } from '@/app/router/routes'
import { FEATURES } from '@/shared/config/features'
import LayoutAccount from '../components/layout-account'

export const apiTokenRoutes: RouteObject[] = FEATURES.apiTokensV2
  ? [
      {
        element: <LayoutAccount />,
        children: [
          {
            index: true,
            lazy: {
              Component: () =>
                import('./pages/api-tokens.page').then((module) => module.ApiTokensPage)
            }
          }
        ]
      }
    ]
  : [
      {
        index: true,
        element: <Navigate to={PATHS.admin.account.security} replace />
      }
    ]
